/**
 * In-memory SWR cache.
 * Module-level Map → persist across re-renders và component unmount/remount.
 * Dữ liệu mất khi reload trang (intentional — fresh data on reload).
 */

const DEFAULT_TTL_MS = 5 * 60 * 1000; // 5 phút

const cache = new Map();
// Track các request đang in-flight để tránh duplicate call
const inflight = new Map();

/**
 * @param {string} key
 * @returns {{ data: any, fetchedAt: number } | null}
 */
export function cacheGet(key, ttlMs = DEFAULT_TTL_MS) {
  const entry = cache.get(key);
  if (!entry) return null;
  if (Date.now() - entry.fetchedAt > ttlMs) return null; // hết hạn
  return entry;
}

/**
 * @param {string} key
 * @param {any} data
 */
export function cacheSet(key, data) {
  cache.set(key, { data, fetchedAt: Date.now() });
}

/** Xóa 1 key (dùng khi cần force refresh) */
export function cacheInvalidate(key) {
  cache.delete(key);
}

/** Xóa toàn bộ cache (dùng khi logout) */
export function cacheClear() {
  cache.clear();
  inflight.clear();
}

/**
 * Chạy fetcher với dedup: nếu cùng key đang fetch thì trả về cùng 1 Promise,
 * tránh N component gọi N API song song cùng lúc.
 *
 * @param {string} key
 * @param {() => Promise<any>} fetcher
 * @returns {Promise<any>}
 */
export function fetchDeduped(key, fetcher) {
  if (inflight.has(key)) return inflight.get(key);

  const promise = fetcher().finally(() => inflight.delete(key));
  inflight.set(key, promise);
  return promise;
}
